(() => {
    'use strict';

    // Map to real theme global classes once found in devtools — keep structure, swap values only
    const THEME = {
        btnPrimary: 'button button--primary cart-detail-actions__cart',
        linkClass: 'link underlined-link'
    };

    const dataSet = {
        "cart": {
            'nl': 'Bekijk Winkelwagen',
            'en': 'View Cart',
            'it': 'Visualizza carrello',
            'fr': 'Panier',
            'de': 'Warenkorb ansehen',
            'es': 'Ver cesta'
        },
        "usp1": {
            'nl': 'Gemakkelijk <b>retourneren</b> binnen 30 dagen',
            'en': 'Easy <b>returns</b> within 30 days',
            'it': '<b>Restituzione</b> facile entro 30 giorni',
            'fr': '<b>Retours</b> faciles sous 30 jours',
            'de': 'Einfache <b>Rückgabe</b> innerhalb von 30 Tagen',
            'es': '<b>Devoluciones</b> fáciles en 30 días'
        },
        "usp2": {
            'nl': 'Levering binnen <b>2 tot 3 werkdagen</b>',
            'en': 'Delivery within <b>2 to 3 business days</b>',
            'it': 'Consegna entro <b>2-3 giorni lavorativi</b>',
            'fr': 'Livraison sous <b>2 à 3 jours ouvrables</b>',
            'de': 'Lieferung innerhalb von <b>2 bis 3 Werktagen</b>',
            'es': 'Entrega en <b>2 a 3 días laborables</b>'
        },
        "subtotal": {
            'nl': 'Subtotaal',
            'en': 'Subtotal',
            'it': 'Subtotale',
            'fr': 'Sous-total',
            'de': 'Zwischensumme',
            'es': 'Subtotal'
        },
        "total": {
            'nl': 'Totaal',
            'en': 'Total',
            'it': 'Totale',
            'fr': 'Total',
            'de': 'Gesamt',
            'es': 'Total'
        },
        "korting": {
            'nl': 'Korting',
            'en': 'Discount',
            'it': 'Sconto',
            'fr': 'Réduction',
            'de': 'Rabatt',
            'es': 'Descuento'
        },
        "verzending": {
            'nl': 'Verzending',
            'en': 'Shipping',
            'it': 'Spedizione',
            'fr': 'Livraison',
            'de': 'Versand',
            'es': 'Envío'
        },
        "gratis": {
            'nl': 'Gratis',
            'en': 'Free',
            'it': 'Gratis',
            'fr': 'Gratuit',
            'de': 'Kostenlos',
            'es': 'Gratis'
        },
        "BESPAAR": {
            'nl': 'BESPAAR',
            'en': 'SAVE',
            'it': 'RISPARMIA',
            'fr': 'ÉCONOMISEZ',
            'de': 'SPAREN',
            'es': 'AHORRA'
        },
        "vatInclude": {
            'nl': 'Btw inbegrepen.',
            'en': 'VAT included.',
            'it': 'IVA inclusa.',
            'fr': 'TVA incluse.',
            'de': 'Inkl. MwSt.',
            'es': 'IVA incluido.'
        },
        "checkout": {
            'nl': 'Veilig afrekenen',
            'en': 'Secure checkout',
            'it': 'Pagamento sicuro',
            'fr': 'Paiement sécurisé',
            'de': 'Sicher bezahlen',
            'es': 'Pago seguro'
        }
    };

    let lang = document.querySelector("html").getAttribute("lang");

    function injectCartExtras(drawer) {
        lang = document.querySelector("html").getAttribute("lang");
        const form = drawer.querySelector("form[action*='/cart'].buy-buttons");
        if (!form) return;
        const checkoutBtn = form.querySelector('[name="checkout"]');
        if (!checkoutBtn) return;

        if (document.querySelector('.cart-drawer free-shipping-bar')) {
            if (document.querySelector(".cart-drawer free-shipping-bar .bf-bar__tier--2 svg") && !document.querySelector('.cart-drawer free-shipping-bar .bf-bar__tier--2 .cart-detail-gift-svg')) {
                document.querySelector(".cart-drawer free-shipping-bar .bf-bar__tier--2 svg").classList.add("cart-detail-hidden");
                document.querySelector(".cart-drawer free-shipping-bar .bf-bar__tier--2 svg").insertAdjacentHTML("beforebegin", `<svg class="cart-detail-gift-svg" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7.00146 4.26115C7.96552 4.25679 8.92942 4.28714 9.89129 4.35215C10.5099 4.39836 11.0914 4.66507 11.53 5.10377C11.9686 5.54248 12.2351 6.12403 12.2812 6.74265C12.3314 7.36507 12.3611 7.99799 12.3611 8.6449C12.3611 9.2924 12.3314 9.9259 12.2812 10.5477C12.2354 11.1666 11.969 11.7484 11.5303 12.1873C11.0917 12.6263 10.5101 12.8932 9.89129 12.9394C8.92938 13.0036 7.9655 13.0337 7.00146 13.0298C6.03722 13.0346 5.07312 13.0046 4.11104 12.94C3.49242 12.8935 2.91099 12.6267 2.47243 12.1879C2.03387 11.7491 1.76729 11.1676 1.72113 10.5489C1.669 9.91595 1.64234 9.28116 1.64121 8.64607C1.64121 7.99857 1.67154 7.36565 1.72113 6.74265C1.76732 6.12413 2.03394 5.54272 2.47253 5.10414C2.91111 4.66556 3.49252 4.39893 4.11104 4.35274C5.07311 4.28765 6.0372 4.2571 7.00146 4.26115ZM7.00146 4.26115V13.031M1.64062 7.6719H12.3605" stroke="#2E2E2E"></path>
            <path d="M10.0028 4.35978L10.6008 4.06986C10.7944 3.97713 10.9672 3.84621 11.1089 3.68498C11.2506 3.52375 11.3583 3.33554 11.4254 3.13165C11.4925 2.92776 11.5178 2.7124 11.4995 2.49851C11.4813 2.28463 11.4201 2.07664 11.3194 1.88703C10.7367 0.79503 9.17743 0.743113 8.52351 1.79486L7.00276 4.24311L5.48143 1.79486C4.8281 0.743113 3.26943 0.79503 2.6861 1.88703C2.58542 2.07656 2.52409 2.28449 2.5058 2.49832C2.4875 2.71216 2.51262 2.92748 2.57963 3.13136C2.64665 3.33525 2.75418 3.52348 2.89578 3.68475C3.03737 3.84603 3.2101 3.97702 3.4036 4.06986L4.00268 4.35978" stroke="#2E2E2E" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>`);
            }
        }

        /* 2. Hide native checkout button, add primary "Bekijk Winkelwagen" + text link "Direct Afrekenen" below it */
        checkoutBtn.classList.add('link');
        if (!drawer.querySelector('#cart-drawer-note') && !drawer.querySelector('.cart-detail-actions')) {
            const actionsHtml = `<div class="cart-detail-actions">
                <a href="/cart" class="${THEME.btnPrimary} button--secondary">${dataSet.cart[lang]}</a>
                </div>`;
            checkoutBtn.insertAdjacentHTML('beforebegin', actionsHtml);
        }

        if (document.querySelector("#cart-drawer-note cart-note textarea")) {
            document.querySelector("#cart-drawer-note cart-note textarea").setAttribute("rows", "1")
            document.querySelector("#cart-drawer-note cart-note textarea").style.height = "60px";
        }
    }

    function injectCartPageExtras() {
        lang = document.querySelector("html").getAttribute("lang");
        const cartForm = document.querySelector("main form.cart-form");
        if (!cartForm) return;
        const cartSection = cartForm.closest('.shopify-section') || cartForm.closest('main') || cartForm;

        /* Remove top USP row shown above cart content — verify real selector in devtools */
        const topUsps = document.querySelector('.cart-top-usps, .cart__usps, [class*="cart-usp"]');
        if (topUsps) topUsps.classList.add('cart-detail-hidden');

        const shippingBar = document.querySelector("main .free-shipping-bar");
        if (shippingBar) {
            const shippingSVG = setInterval(() => {
                if (shippingBar.querySelector("[data-free-shipping] .free-shipping-bar__image svg")) {
                    shippingBar.querySelector("[data-free-shipping]").insertAdjacentElement("afterbegin", shippingBar.querySelector("[data-free-shipping] .free-shipping-bar__image svg"));
                }
                if (shippingBar.querySelector("[data-free-gift] .free-shipping-bar__image svg")) {
                    shippingBar.querySelector("[data-free-gift]").insertAdjacentElement("afterbegin", shippingBar.querySelector("[data-free-gift] .free-shipping-bar__image svg"));
                }
                if (shippingBar.querySelector("[data-free-shipping] .free-shipping-bar__image svg") && shippingBar.querySelector("[data-free-gift] .free-shipping-bar__image svg")) {
                    clearInterval(shippingSVG)
                }
            }, 100);
        }

        /* USP list under payment method icons */
        const paymentsEl = document.querySelector('.cart-order__recap .cart-page-trustpilot-widget');
        if (paymentsEl && !document.querySelector('.cart-detail-usps')) {
            const uspsHtml = `<ul class="cart-detail-usps">
                <li class="cart-detail-usps__item cart-detail-usps__item--returns">${dataSet.usp1[lang]}</li>
                <li class="cart-detail-usps__item cart-detail-usps__item--delivery">${dataSet.usp2[lang]}</li>
            </ul>`;
            paymentsEl.insertAdjacentHTML('afterend', uspsHtml);
        }

        let itemCount = 0, finalTotal = 0;
        if (!document.querySelector(".cart-detail-cart-summary")) {
            let total = 0, korting = 0;
            document.querySelector(".order-summary__header > tr").insertAdjacentHTML("beforeend", `<th class="cart-detail-action-header"></th>`);
            document.querySelectorAll(".order-summary__body > tr").forEach((e) => {
                if (e.querySelector("td > line-item-quantity")) {
                    itemCount++;
                    const minusBtn = e.querySelector(".line-item .line-item__info-bottom line-item-quantity:has(.quantity-selector) .quantity-selector button").cloneNode(true);
                    minusBtn.classList.add("cart-detail-minus-btn");
                    const plusBtn = e.querySelector(".line-item .line-item__info-bottom line-item-quantity:has(.quantity-selector) .quantity-selector quantity-input + button").cloneNode(true);
                    plusBtn.classList.add("cart-detail-plus-btn");
                    e.querySelector("td > line-item-quantity").insertAdjacentElement("afterbegin", minusBtn);
                    e.querySelector("td > line-item-quantity").insertAdjacentElement("beforeend", plusBtn);
                    e.querySelector(".cart-detail-minus-btn").addEventListener("click", () => {
                        e.querySelector(".line-item .line-item__info-bottom line-item-quantity:has(.quantity-selector) .quantity-selector button").click();
                        setTimeout(() => {
                            e.querySelector("td > line-item-quantity input").value = e.querySelector(".line-item .line-item__info-bottom line-item-quantity:has(.quantity-selector) .quantity-selector quantity-input input").value;
                        }, 500);
                    });
                    e.querySelector(".cart-detail-plus-btn").addEventListener("click", () => {
                        e.querySelector(".line-item .line-item__info-bottom line-item-quantity:has(.quantity-selector) .quantity-selector quantity-input + button").click();
                        setTimeout(() => {
                            e.querySelector("td > line-item-quantity input").value = e.querySelector(".line-item .line-item__info-bottom line-item-quantity:has(.quantity-selector) .quantity-selector quantity-input input").value;
                        }, 500);
                    });

                }
                if (e.querySelector(".line-item .line-item__info line-item-quantity .line-item__remove")) {
                    e.insertAdjacentHTML("beforeend", `<td class="cart-detail-remove-item align-center"></td>`);
                    e.querySelector(".cart-detail-remove-item").insertAdjacentElement("afterbegin", e.querySelector(".line-item .line-item__info line-item-quantity .line-item__remove").cloneNode(true));
                }
                if (e.querySelector(".line-item__info .price-list sale-price") && !e.querySelector(".line-item__info .price-list .cart-detail-sale-price")) {
                    const qty = Number(e.querySelector("line-item-quantity .quantity-selector__input").value), price = euroToNumber(e.querySelector(".line-item__info .price-list sale-price").textContent.trim().match(/[\d.,]+/)[0]);
                    if (isNaN(qty) || qty == 0) {
                        qty = 1;
                    }
                    const perProductPrice = price / qty;
                    e.querySelector(".line-item__info .price-list sale-price").insertAdjacentHTML("afterend", `<div class="cart-detail-sale-price text-base font-medium lh-14">€${formatPrice(perProductPrice)}</div>`);
                }
                if (e.querySelector(".line-item__info .price-list compare-at-price")) {
                    let qty = Number(e.querySelector("line-item-quantity .quantity-selector__input").value);
                    if (isNaN(qty) || qty == 0) {
                        qty = 1;
                    }
                    let oldPrice = euroToNumber(e.querySelector(".line-item__info .price-list compare-at-price").textContent.trim().match(/[\d.,]+/)[0]);
                    let newPrice = euroToNumber(e.querySelector(".line-item__info .price-list sale-price").textContent.trim().match(/[\d.,]+/)[0]);
                    total += oldPrice;
                    korting += (oldPrice - newPrice);


                    if (!e.querySelector(".line-item__info .price-list .cart-detail-compare-at-price")) {
                        let compareAtPrice = euroToNumber(e.querySelector(".line-item__info .price-list compare-at-price").textContent.trim().match(/[\d.,]+/)[0]);
                        const perProductcompareAtPrice = compareAtPrice / qty;
                        e.querySelector(".line-item__info .price-list compare-at-price").insertAdjacentHTML("afterend", `<div class="cart-detail-compare-at-price text-base text-subdued line-through lh-14">€${formatPrice(perProductcompareAtPrice)}</div>`);
                    }
                } else if (e.querySelector("sale-price")) {
                    total += euroToNumber(e.querySelector(".line-item__info .price-list sale-price").textContent.trim().match(/[\d.,]+/)[0]);
                }
            });
            if (document.querySelector(".cart-form__totals .h5:last-child")) {
                finalTotal = document.querySelector(".cart-form__totals .h5:last-child").textContent.trim().match(/[\d.,]+/)[0];
            }
            document.querySelector(".cart-form__totals").insertAdjacentHTML("afterend", `
                <div class="cart-detail-cart-summary">
                    <div class="${korting == 0 ? '' : 'cart-detail-line-through'}"><span>${dataSet.subtotal[lang]}</span> <span id="cart-detail-subtotal">€${formatPrice(total)}</span></div>
                    <div class="${korting == 0 ? 'cart-detail-hidden' : ''}"><span>${dataSet.korting[lang]}</span> <span id="cart-detail-discount">${dataSet.BESPAAR[lang]} €${formatPrice(korting)}</span></div>
                    <div class="cart-detail-shipping-charge ${euroToNumber(finalTotal.replace("€", "")) >= 60 ? "cart-detail-show" : ""}"><span>${dataSet.verzending[lang]}</span> <span id="cart-detail-delivery">${dataSet.gratis[lang]}</span></div>
                    <div class="cart-detail-coupon"><span></span> <span><span class="amount"></span></span></div>
                    <div class="cart-detail-total"><b>${dataSet.total[lang]}</b> <span id="cart-detail-total">€${finalTotal}</span></div>
                    <span class="cart-detail-vat-include-text">${dataSet.vatInclude[lang]}</span>
                </div>
            `);
        }

        if (document.querySelector("main form.cart-form .cart-form__note textarea")) {
            document.querySelector("main form.cart-form .cart-form__note textarea").setAttribute("rows", "1")
        }

        if (document.querySelector("main form.cart-form button[name='checkout'] > div")) {
            document.querySelector("main form.cart-form button[name='checkout'] > div").innerHTML = `<svg role="presentation" fill="none" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-picto-lock" viewBox="0 0 24 24">
        <path d="M3.236 18.182a5.071 5.071 0 0 0 4.831 4.465 114.098 114.098 0 0 0 7.865-.001 5.07 5.07 0 0 0 4.831-4.464 23.03 23.03 0 0 0 .165-2.611c0-.881-.067-1.752-.165-2.61a5.07 5.07 0 0 0-4.83-4.465c-1.311-.046-2.622-.07-3.933-.069a109.9 109.9 0 0 0-3.933.069 5.07 5.07 0 0 0-4.83 4.466 23.158 23.158 0 0 0-.165 2.609c0 .883.067 1.754.164 2.61Z" fill="currentColor" fill-opacity=".12" stroke="currentColor"></path>
        <path d="M17 8.43V6.285A5 5 0 0 0 7 6.286V8.43" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
        <path d="M12 17.714a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Z" stroke="currentColor"></path>
      </svg>` + dataSet.checkout[lang];
            document.querySelector("main form.cart-form button[name='checkout']").classList.add("button--secondary")
        }

        if (!document.querySelector(".cart-detail-short-cart-summary")) {
            document.querySelector(".cart-header h1").insertAdjacentHTML("afterend", `
                <div class="cart-detail-short-cart-summary">
                    <div><span class="item-count"><span class="count">${itemCount}</span> artikelen in winkelwagen</span> <span class="amount">${document.querySelector(".cart-form__totals .h5:last-child").textContent.trim()}</span></div>
                    <button type="submit" class="button button--xl w-full button--secondary cart-detail-checkout-btn" name="checkout" is="custom-button"><div><svg role="presentation" fill="none" focusable="false" stroke-width="2" width="18" height="18" class="icon icon-picto-lock" viewBox="0 0 24 24">
                            <path d="M3.236 18.182a5.071 5.071 0 0 0 4.831 4.465 114.098 114.098 0 0 0 7.865-.001 5.07 5.07 0 0 0 4.831-4.464 23.03 23.03 0 0 0 .165-2.611c0-.881-.067-1.752-.165-2.61a5.07 5.07 0 0 0-4.83-4.465c-1.311-.046-2.622-.07-3.933-.069a109.9 109.9 0 0 0-3.933.069 5.07 5.07 0 0 0-4.83 4.466 23.158 23.158 0 0 0-.165 2.609c0 .883.067 1.754.164 2.61Z" fill="currentColor" fill-opacity=".12" stroke="currentColor"></path>
                            <path d="M17 8.43V6.285A5 5 0 0 0 7 6.286V8.43" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                            <path d="M12 17.714a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Z" stroke="currentColor"></path>
                        </svg>${dataSet.checkout[lang]}</div><span class="button__loader">
                        <span></span>
                        <span></span>
                        <span></span>
                    </span></button>
                </div>
            `);
            document.querySelector(".cart-detail-short-cart-summary .cart-detail-checkout-btn").addEventListener("click", () => {
                document.querySelector(".cart-detail-short-cart-summary .cart-detail-checkout-btn").setAttribute("aria-busy", "true");
                document.querySelector("main form.cart-form button[name='checkout']").click();
            })
        } else {
            document.querySelector(".cart-detail-cart-summary .item-count .count").textContent = itemCount;
            document.querySelector(".cart-detail-cart-summary .amount .price").textContent = finalTotal;
        }

        /* Cross-sell — fetch homepage, clone its recommended-products module, drop below cart items */
        if (!document.querySelector('.cart-detail-cross-sell')) {
            let url = lang == 'nl' ? '/' : `/${lang}`
            fetch(url)
                .then(res => res.text())
                .then(html => {
                    const doc = new DOMParser().parseFromString(html, 'text/html');
                    const module = doc.querySelector('.shopify-section:has(.featured-collections-tabs-content)');
                    if (!module || document.querySelector('.cart-detail-cross-sell')) return;
                    const clone = module.cloneNode(true);
                    clone.classList.add('cart-detail-cross-sell');
                    cartSection.insertAdjacentElement('afterend', clone);

                    // Re-init drag-scroll — cloneNode doesn't carry over custom element connectedCallback
                    const tracks = clone.querySelectorAll('scroll-carousel');
                    tracks.forEach((track) => {
                        addDragScroll(track);
                    });
                })
                .catch(() => { });
        }
    }

    function addDragScroll(track) {
        if (!track || track.dataset.cartSliderDrag) return;
        track.dataset.cartSliderDrag = '1';

        // Let browser handle touch natively with momentum
        track.style.overflowX = 'auto';
        track.style.webkitOverflowScrolling = 'touch'; // iOS native momentum
        track.style.scrollSnapType = 'x mandatory'; // match homepage snap if any
        track.style.cursor = 'grab';
        track.style.userSelect = 'none';

        let isDown = false, startX, scrollLeft, rafId;
        const history = [];

        function getVelocity() {
            if (history.length < 2) return 0;
            const last = history[history.length - 1];
            const first = history[0];
            const dt = last.t - first.t;
            return dt > 0 ? (first.x - last.x) / dt * 16 : 0;
        }

        function momentum(vel) {
            if (Math.abs(vel) < 0.3) return;
            track.scrollLeft += vel;
            rafId = requestAnimationFrame(() => momentum(vel * 0.94));
        }

        track.addEventListener('mousedown', (e) => {
            cancelAnimationFrame(rafId);
            isDown = true;
            history.length = 0;
            track.style.cursor = 'grabbing';
            startX = e.pageX - track.offsetLeft;
            scrollLeft = track.scrollLeft;
            history.push({ x: e.pageX, t: Date.now() });
        });

        track.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX);
            history.push({ x: e.pageX, t: Date.now() });
            track.classList.add("is-scroll-now");
            if (history.length > 5) history.shift();
        });

        document.addEventListener('mouseup', () => {
            if (!isDown) return;
            isDown = false;
            track.style.cursor = 'grab';
            track.classList.remove("is-scroll-now");
            momentum(getVelocity());
        });
    }

    function euroToNumber(euroString) {
        // Remove non-numeric characters except ',' and '.'
        let cleanedString = euroString.replace(/[^0-9,.-]/g, "").replace(".", "").replace(",", ".").replace(".-", "");

        // Convert to a number
        let number = parseFloat(cleanedString);

        return isNaN(number) ? "" : number;
    }

    // Function to format prices based on locale
    function formatPrice(price) {
        // Format the price using Intl.NumberFormat
        return new Intl.NumberFormat('de-DE', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price);
    }

    if(document.querySelector(".cart-drawer")) {
        const cartDrawer = document.querySelector(".cart-drawer");

        injectCartExtras(cartDrawer);

        // Cart drawer re-renders on AJAX update — re-check and re-inject if our blocks got wiped
        const config = { childList: true, subtree: true, attributes: true };
        let running = false;
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                const shouldRun = mutations.some(m =>
                    m.type === "childList" && m.addedNodes.length
                );

                if (!shouldRun) return;
                // if (running) return;
                const freshDrawer = document.querySelector('.cart-drawer');
                if (!freshDrawer) return;
                const checkoutVisible = freshDrawer.querySelector('[name="checkout"]:not(.cart-detail-hidden)');
                const missing = !freshDrawer.querySelector('.cart-detail-note')
                    || !freshDrawer.querySelector('.cart-detail-actions')
                    || !freshDrawer.querySelector('.cart-detail-payments')
                    || !freshDrawer.querySelector('.cart-detail-reviews');
                if (missing) {
                    injectCartExtras(cartDrawer);
                }
                running = true;
                setTimeout(function () { running = false; }, 500);
            });
        });
        // observer.disconnect();
        observer.observe(document.querySelector(".shopify-section:has(cart-drawer)"), config);
    }

    if(document.querySelector("main form.cart-form")) {
        injectCartPageExtras();
    }

    if(document.querySelector(".zoom-image--enabled")) {
        function getGreenBtn() {
            const allBtns = document.querySelectorAll('a, button')
            if (allBtns.length) {
                allBtns.forEach(el => {

                    const bg = getComputedStyle(el).backgroundColor;

                    const match = bg.match(/\d+/g);

                    if (!match) return;

                    const [r, g, b] = match.map(Number);

                    if (r === 0 && g === 127 && b === 78) {
                        el.classList.add('cart-detail-red-btn');
                    }
                });
            }
        }
        getGreenBtn();

        const config = { childList: true, characterData: true, subtree: true, attributes: true };
        let running = false;
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (running) return;

                getGreenBtn();
                // observer.disconnect();
                running = true;
                setTimeout(function () { running = false; }, 500);
            });
        });
        // observer.disconnect();
        observer.observe(document.body, config);
    }

    const targetSelector = '.cart-page-trustpilot-widget';

    /*
     * Move the complete initialized wrapper, not only the iframe.
     */
    const sourceSelector =
        '.cart-drawer__trustpilot-holder ' +
        '.trustpilot-micro-combo-mobile-one-line';


    function waitForElement(
        selector,
        callback,
        minElements = 1,
        timer = 20000,
        frequency = 100
    ) {
        const elements = document.querySelectorAll(selector);

        if (elements.length >= minElements) {
            callback(elements);
            return;
        }

        if (timer <= 0) {
            return;
        }

        setTimeout(() => {
            waitForElement(
                selector,
                callback,
                minElements,
                timer - frequency,
                frequency
            );
        }, frequency);
    }

    function createTargetSection(target) {
        let section = document.getElementById('cart-detail-review-slider');

        if (section) {
            return section;
        }

        const targetSection =
            target || target.closest('.shopify-section') ||
            target.parentElement;

        if (!targetSection?.parentNode) {
            return null;
        }

        section = document.createElement('section');

        section.id = 'cart-detail-review-slider';
        section.className =
            'cart-detail-review-slider custom-container cart-detail-trustpilot';

        section.innerHTML = `
            <div class="cart-detail-review-slider__inner"></div>
        `;

        targetSection.insertAdjacentElement('beforeend', section);

        return section;
    }

    function moveTrustpilotWidget() {
        const target = document.querySelector(targetSelector);
        const source = document.querySelector(sourceSelector);

        if (!target || !source) {
            return;
        }

        const section = createTargetSection(target);

        if (!section) {
            return;
        }

        const inner = section.querySelector(
            '.cart-detail-review-slider__inner'
        );

        /*
         * Already moved.
         */
        if (inner.contains(source)) {
            return;
        }

        /*
         * Move the actual initialized widget.
         * Do not clone it.
         */
        inner.appendChild(source);

        source.classList.add(
            'cart-detail-review-slider__trustpilot-widget'
        );
    }

    waitForElement(targetSelector, () => {
        waitForElement(
            `${sourceSelector} iframe`,
            () => {
                moveTrustpilotWidget();
            }
        );
    });

    /*
     * Handle Shopify cart rerenders.
     */
    let observerTimer;

    const observer = new MutationObserver(() => {
        clearTimeout(observerTimer);

        observerTimer = setTimeout(() => {
            const section =
                document.getElementById('cart-detail-review-slider');

            const source =
                document.querySelector(sourceSelector);

            /*
             * Only rerun when the target section/widget disappeared.
             */
            if (!section && source) {
                moveTrustpilotWidget();
            }
        }, 200);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})();